import {EnquiryProvider} from "../../../../../../../api/generated";
import {SelectOption} from "../../../../../../elements/select/SelectDropdown";

export const allEnquiryProviderOptions: SelectOption<EnquiryProvider>[] = [
    {
        label: "No Provider",
        value: EnquiryProvider.NoProvider
    },
    {
        label: "Dragon2000",
        value: EnquiryProvider.Dragon2000
    },
    {
        label: "EM2",
        value: EnquiryProvider.Em2
    }
]

export const getEnquiryProviderName = (enquiryProvider: EnquiryProvider) => {
    const option = allEnquiryProviderOptions.filter(o => o.value === enquiryProvider)

    if (option && option.length === 1) {
        return option[0].label
    }

    throw new Error(`Unable to handle enquiryProvider: ${enquiryProvider} correctly`)
}
